export default "__VITE_ASSET__CxQjFZH9__"